import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import IOSSwitch from "components/Elements/IOSSwitch";
import PausedBadge from "./PausedBadge";

const useStyles = makeStyles()(() => ({
	row: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "10px",
		marginBottom: "2px",
	},
	titleGroup: {
		display: "flex",
		alignItems: "center",
		gap: "10px",
		flex: 1,
		flexWrap: "wrap",
	},
	title: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "16px",
	},
	format: {
		color: "#6b7280",
		fontWeight: 500,
	},
}));

const SubscriptionHeader = ({ subscription, onToggle }) => {
	const { classes } = useStyles();
	const heading = subscription.name || subscription.reportName;
	return (
		<div className={classes.row}>
			<div className={classes.titleGroup}>
				<Typography className={classes.title}>
					{heading}{" "}
					<span className={classes.format}>
						({subscription.reportName} · {subscription.outputFormat})
					</span>
				</Typography>
				{!subscription.isActive ? <PausedBadge /> : null}
			</div>
			<IOSSwitch
				name={`subscription-${subscription.id}`}
				hideLabel
				currentStatus={subscription.isActive}
				onChange={onToggle}
				disable={false}
			/>
		</div>
	);
};

export default SubscriptionHeader;
